import http from '@/http/http.js';
let baseURL = '';
if (process.env.NODE_ENV == 'development') {
  //开发环境
  baseURL = '/api/web/zzzd/zzzd/springBoard';
} else if (process.env.NODE_ENV == 'production') {
  //生产环境
  baseURL = '/web/zzzd/zzzd/springBoard';
}
//获取一级大类
export function getIndustries(params) {
    return http.post(baseURL, {
      actionProcess: "zzzd",
      actionType: 'getIndustries',
      actionBody: params,
    });
  }
//获取二级大类
export function getSecondIndustries(params) {
    return http.post(baseURL, {
      actionProcess: "zzzd",
      actionType: 'getSecondIndustries',
      actionBody: params,
    });
  }
//根据行业ID 查询所有相关的资质
export function getQualificationByIndustry(params) {
    return http.post(baseURL, {
      actionProcess: "zzzd",
      actionType: 'getQualificationByIndustry',
      actionBody: params,
    });
  }
//查看结果
export function check(params) {
    return http.post(baseURL, {
      actionProcess: "zzzd",
      actionType: 'check',
      actionBody: params,
    });
}
//免费咨询
export function counselling(params) {
    return http.post(baseURL, {
      actionProcess: "zzzd",
      actionType: 'counselling',
      actionBody: params,
    });
}
// 营业执照
export function uploadBusiness(params) {
  return http.post(baseURL, {
    actionProcess: "zzzd",
    actionType:'uploadBusiness',
    actionBody: params,
  });
}

// 人工评估 (开始入驻)
export function manualEvaluation(params) {
  return http.post(baseURL, {
    actionProcess: "zzzd",
    actionType:'manualEvaluation',
    actionBody: params,
  });
}

// 诊断列表
export function diagnosisInfo(params) {
  return http.post(baseURL, {
    actionProcess: "zzzd",
    actionType:'diagnosisInfo',
    actionBody: params,
  });
}
// 诊断详情
export function diagnosisDetail(params) {
  return http.post(baseURL, {
    actionProcess: "zzzd",
    actionType:'diagnosisDetail',
    actionBody: params,
  });
}
// 企业信息
export function enterpriseInfo(params) {
  return http.post(baseURL, {
    actionProcess: "zzzd",
    actionType:'enterpriseInfo',
    actionBody: params,
  });
}